import Svg, { Path } from "react-native-svg";
const ArrowRight = () => (
  <Svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<Path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</Svg>

);
export default ArrowRight;
